import { CheckCircle2, MailCheck, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: ShieldCheck, label: "Secure link validation" },
  { icon: MailCheck, label: "Code sent to the new email" },
  { icon: CheckCircle2, label: "Sign in again after completion" },
];

export default function Nd1ChangeEmailMarketing() {
  return (
    <aside className="nd1-auth-aside nd1-auth-aside--signin" aria-label="Email change guidance">
      <div className="nd1-auth-aside__copy">
        <p className="nd1-auth-card__eyebrow">Secure account change</p>
        <h1 className="nd1-auth-aside__title">
          <span className="nd1-ink">Update your sign-in</span>
          <span className="nd1-ink-green">email safely.</span>
        </h1>
        <p className="nd1-auth-aside__lede">
          Email changes use a secure link and a verification code so your account stays protected.
        </p>
      </div>
      <ul className="nd1-auth-aside__features">
        {FEATURES.map(({ icon: Icon, label }) => (
          <li key={label}>
            <Icon className="nd1-icon" aria-hidden="true" />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
